(function () {
    'use strict';

    angular
        .module('app.discover')
        .factory('discoverService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                // cancelRequestId: provide the id if want to cancel all previous pending request with this id
                function handleRequest(url, method, params, loader, cancelRequestId) {
                    var deferred = $q.defer();
                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 
                    
                    if (cancelRequestId) {
                        // check pending requests to cancel
                        $http.pendingRequests.forEach(function(request) {
                            if (request.cancelRequestId === cancelRequestId) {
                                request.cancel.resolve(false);
                            }
                        });
                        req.cancelRequestId = cancelRequestId; // provide request id
                        req.timeout = deferred.promise; // cancel promise
                        req.cancel = deferred; // provide promise
                    }

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (result) {
                            deferred.reject(result);
                        });

                    return deferred.promise;
                }

                function loadNodeOfSlider() {
                    var url_loadNodeOfSlider = $rootScope.apiUrl + 'discover/getSliderData';
                    return handleRequest(url_loadNodeOfSlider, "GET", null, false);
                }

                function searchDiscoverPost(params, loader) {
                    var url = $rootScope.apiUrl + 'discover/searchDiscoverPost';
                    return handleRequest(url, 'POST', params, loader, "searchDiscoverPost");
                }

                function searchDiscoverInfluencer(params, loader) {
                    var url = $rootScope.apiUrl + 'discover/searchDiscoverInfluencer';
                    return handleRequest(url, 'POST', params, loader, "searchDiscoverInfluencer");
                }

                function saveDiscoverSearchFilters(params, loader) {
                    var url = $rootScope.apiUrl + 'discover/saveSearchHistory';
                    return handleRequest(url, 'POST', params, loader);
                }

                function updateDiscoverSearchFilters(params, loader) {
                    var url = $rootScope.apiUrl + 'discover/updateSearchHistory ';
                    return handleRequest(url, 'PUT', params, loader);
                }

                function getDiscoverSearchHistories(params, loader) {
                    var url = $rootScope.apiUrl + 'discover/getSearchHistories';
                    return handleRequest(url, "GET", null, loader);
                }

                function deleteDiscoverSearchHistory(id, loader) {
                    var url = $rootScope.apiUrl + 'discover/deleteSearchHistory/' + id;
                    return handleRequest(url, "DELETE", null, loader);
                }

                function clearDiscoverSearchHistories(type, loader) {
                    var url = $rootScope.apiUrl + 'discover/clearSearchHistories/' + type;
                    return handleRequest(url, "DELETE", null, loader);
                }

                function checkIfCanSaveSearchHistory(loader) {
                    var url = $rootScope.apiUrl + 'discover/checkIfCanSaveSearchHistory';
                    return handleRequest(url, "GET", null, loader);
                }

                function isMentionExisted(params, loader) {
                    var url = $rootScope.apiUrl + 'mention/exists';
                    return handleRequest(url, 'POST', params, loader);
                }

                function addNewProjectMention(params, loader) {
                    var url = $rootScope.apiUrl + 'mention/addNewProjectMention';
                    return handleRequest(url, 'POST', params, loader);
                }

                service.loadNodeOfSlider = loadNodeOfSlider;
                service.searchDiscoverPost = searchDiscoverPost;
                service.searchDiscoverInfluencer = searchDiscoverInfluencer;
                service.saveDiscoverSearchFilters = saveDiscoverSearchFilters;
                service.getDiscoverSearchHistories = getDiscoverSearchHistories;
                service.deleteDiscoverSearchHistory = deleteDiscoverSearchHistory;
                service.clearDiscoverSearchHistories = clearDiscoverSearchHistories;
                service.updateDiscoverSearchFilters = updateDiscoverSearchFilters;
                service.checkIfCanSaveSearchHistory = checkIfCanSaveSearchHistory;
                service.isMentionExisted = isMentionExisted;
                service.addNewProjectMention = addNewProjectMention;

                return service;
            }
        ]);
})();
